import * as React from 'react';
import {
	chakra,
	ImageProps,
	forwardRef,
} from '@chakra-ui/react';
import surveyUpdateIcon from 'Assets/svg/surveyUpdateIcon.svg';

export const SurveyUpdateNotificationIcon = forwardRef<ImageProps, 'img'>((props, ref) => {
	return <chakra.img src={surveyUpdateIcon} ref={ref} {...props} />;
}); 